import PropTypes from 'prop-types';

export default PropTypes.arrayOf(PropTypes.shape({
  brand: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired,
  channelsAvailability: PropTypes.shape({
    defaultAvailability: PropTypes.shape({
      canBeDownloaded: PropTypes.bool
    })
  }).isRequired,
  descriptionShortened: PropTypes.string.isRequired,
  descriptionBullets: PropTypes.arrayOf(
    PropTypes.string
  ),
  hasOurExpertsLoveTag: PropTypes.bool.isRequired,
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string.isRequired,
      linkUrl: PropTypes.string
    })
  ),
  id: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  isFlashSale: PropTypes.bool.isRequired,
  isOnlineCreditAvailable: PropTypes.bool,
  isOutOfStock: PropTypes.bool.isRequired,
  link: PropTypes.string.isRequired,
  onlineCreditLinkMessage: PropTypes.string,
  price: PropTypes.shape({}).isRequired,
  promoMessages: PropTypes.shape({
    isOnlineOnly: PropTypes.bool.isRequired,
    marketingMessages: PropTypes.arrayOf(PropTypes.shape({
      class: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    }).isRequired),
    numberOfDealsAvailableTranslation: PropTypes.string,
    badges: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      src: PropTypes.string.isRequired
    }))
  }).isRequired,
  review: PropTypes.shape({
    score: PropTypes.number.isRequired,
    reviewCount: PropTypes.number.isRequired
  }),
  title: PropTypes.string.isRequired,
  beacons: PropTypes.shape({
    onLoad: PropTypes.string,
    onView: PropTypes.string
  })
}));
